import { render, staticRenderFns } from "./task-header.vue?vue&type=template&id=1ed2b753&scoped=true&"
import script from "./task-header.vue?vue&type=script&lang=tsx&"
export * from "./task-header.vue?vue&type=script&lang=tsx&"
import style0 from "./task-header.vue?vue&type=style&index=0&id=1ed2b753&prod&lang=scss&scoped=true&"
import style1 from "./task-header.vue?vue&type=style&index=1&id=1ed2b753&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2b753",
  null
  
)

export default component.exports